import React from 'react';

const SecurityInfoContent = () => {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Política de Segurança – Justiçai</h2>
      
      <p className="text-sm text-muted-foreground">
        Última atualização: 02 de setembro de 2025
      </p>
      
      <p>
        A Octopus Group – CNPJ 34.997.786/0001-85 ("Octopus Group", "nós"), responsável pelo desenvolvimento da 
        tecnologia Laib e operação da plataforma Justiçai ("Plataforma"), reconhece a sensibilidade das informações 
        jurídicas e declara seu compromisso em proteger os dados de todos os usuários, garantindo confidencialidade, 
        integridade e disponibilidade em todos os processos.
      </p>
      
      <section>
        <h3 className="text-md font-medium mb-2">1. Compromisso com a Segurança</h3>
        <p>
          O Justiçai adota uma postura proativa de segurança, com investimentos contínuos em tecnologia, governança e treinamento. 
          Todas as medidas estão alinhadas com a LGPD (Lei nº 13.709/2018) e padrões internacionais, como ISO/IEC 27001, 
          SOC 2 e PCI DSS.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">2. Infraestrutura e Segurança de Sistemas</h3>
        
        <h4 className="font-medium mt-3">2.1. Infraestrutura em Nuvem Segura</h4>
        <p className="mt-1">• Hospedagem em provedores de nuvem líderes, certificados em conformidade global;</p>
        <p className="mt-1">• Monitoramento e mitigação de ameaças em tempo real;</p>
        <p className="mt-1">• Arquitetura resiliente e redundante para garantir alta disponibilidade.</p>
        
        <h4 className="font-medium mt-3">2.2. Criptografia de Dados</h4>
        <p className="mt-1">• Em trânsito: TLS 1.3 em todas as comunicações;</p>
        <p className="mt-1">• Em repouso: criptografia AES-256;</p>
        <p className="mt-1">• Gestão de chaves: chaves rotacionadas periodicamente, sob políticas rígidas de controle.</p>
        
        <h4 className="font-medium mt-3">2.3. Controles de Acesso</h4>
        <p className="mt-1">• Princípio do menor privilégio;</p>
        <p className="mt-1">• Autenticação multifator (MFA) para sistemas críticos;</p>
        <p className="mt-1">• Auditoria contínua de acessos com logs detalhados e rastreáveis.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">3. Segurança da Aplicação</h3>
        
        <h4 className="font-medium mt-3">3.1. Desenvolvimento Seguro</h4>
        <p className="mt-1">• Integração de práticas Secure SDLC em todo o ciclo de desenvolvimento;</p>
        <p className="mt-1">• Revisão de código com análise estática e dinâmica;</p>
        <p className="mt-1">• Testes de penetração internos e externos regulares.</p>
        
        <h4 className="font-medium mt-3">3.2. Proteção contra Ameaças</h4>
        <p className="mt-1">• Firewall de aplicação web (WAF) ativo;</p>
        <p className="mt-1">• Defesas contra SQL Injection, XSS, CSRF e outras vulnerabilidades;</p>
        <p className="mt-1">• Limitação de taxa (rate limiting) contra ataques de força bruta e DoS;</p>
        <p className="mt-1">• Monitoramento automatizado de tráfego suspeito.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">4. Segurança de Contas de Usuários</h3>
        
        <h4 className="font-medium mt-3">4.1. Autenticação</h4>
        <p className="mt-1">• Senhas com hashing avançado + salt;</p>
        <p className="mt-1">• Suporte a autenticação multifator (MFA);</p>
        <p className="mt-1">• Políticas de senha fortes e renovação periódica.</p>
        
        <h4 className="font-medium mt-3">4.2. Sessões</h4>
        <p className="mt-1">• Tokens de sessão protegidos e rotacionados;</p>
        <p className="mt-1">• Expiração automática de sessões inativas;</p>
        <p className="mt-1">• Bloqueio temporário após múltiplas tentativas malsucedidas.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">5. Segurança Operacional</h3>
        
        <h4 className="font-medium mt-3">5.1. Monitoramento e Resposta</h4>
        <p className="mt-1">• Monitoramento 24/7 de infraestrutura e aplicações;</p>
        <p className="mt-1">• Sistemas de detecção e prevenção de intrusão (IDS/IPS);</p>
        <p className="mt-1">• Equipe de Resposta a Incidentes com planos documentados.</p>
        
        <h4 className="font-medium mt-3">5.2. Backup e Continuidade</h4>
        <p className="mt-1">• Backups criptografados regulares;</p>
        <p className="mt-1">• Armazenamento redundante em diferentes regiões;</p>
        <p className="mt-1">• Planos de Continuidade de Negócios (BCP) e Recuperação de Desastres (DRP) testados regularmente.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">6. Segurança da Inteligência Artificial</h3>
        
        <h4 className="font-medium mt-3">6.1. Treinamento Seguro</h4>
        <p className="mt-1">• Dados de treinamento anonimizados ou pseudonimizados;</p>
        <p className="mt-1">• Revisão para minimizar vieses e vulnerabilidades nos modelos;</p>
        <p className="mt-1">• Validações específicas de segurança para machine learning.</p>
        
        <h4 className="font-medium mt-3">6.2. Isolamento de Dados</h4>
        <p className="mt-1">• Segregação entre dados de diferentes usuários;</p>
        <p className="mt-1">• Controles granulares para evitar exposição cruzada;</p>
        <p className="mt-1">• Processamento protegido por camadas de segurança.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">7. Avaliações e Certificações</h3>
        <p className="mt-1">• Auditorias independentes de segurança realizadas regularmente;</p>
        <p className="mt-1">• Testes de penetração por equipes terceirizadas;</p>
        <p className="mt-1">• Varreduras de vulnerabilidade contínuas (automatizadas e manuais).</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">8. Segurança Física</h3>
        <p className="mt-1">• Data centers certificados com controles de segurança física;</p>
        <p className="mt-1">• Acesso físico com autenticação multifator;</p>
        <p className="mt-1">• Vigilância e segurança 24/7;</p>
        <p className="mt-1">• Redundância de energia, rede e refrigeração.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">9. Treinamento e Conscientização</h3>
        <p className="mt-1">• Programa contínuo de awareness em segurança;</p>
        <p className="mt-1">• Simulações de phishing e exercícios práticos;</p>
        <p className="mt-1">• Políticas claras de conduta e sanções para violações.</p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">10. Reporte de Vulnerabilidades</h3>
        <p>
          Encorajamos o reporte responsável de falhas de segurança.
          Caso identifique vulnerabilidade em nossa Plataforma, entre em contato:
        </p>
        <p className="mt-2">
          📧 E-mail: security@laib.com.br
        </p>
        <p className="mt-2">
          Todos os relatórios serão analisados de forma célere e profissional.
        </p>
      </section>
      
      <section>
        <h3 className="text-md font-medium mb-2">11. Melhoria Contínua</h3>
        <p>
          A segurança é um processo dinâmico. A Octopus Group mantém um ciclo contínuo de monitoramento, prevenção e 
          inovação, com revisões periódicas das políticas e tecnologias aplicadas.
        </p>
      </section>
    </div>
  );
};

export default SecurityInfoContent;